import React from 'react';

import AverageSessionsSection from './components/AverageSessionsSection';
import CoachingJourney from './components/CoachingJourney';
import LearningAcademySection from './components/LearningAcademySection';
import LearningBottomSection from './components/LearningBottomSection';
import LookerDashboardLayout from '../../components/LookerDashboardLayout';

export function LookerEngagementDashboard() {
  return (
    <LookerDashboardLayout>
      <AverageSessionsSection />
      <CoachingJourney />
      <LearningAcademySection />
      <LearningBottomSection />
    </LookerDashboardLayout>
  );
}
